/* eslint-disable no-undef */
/* eslint-disable no-unused-vars */
import axios from 'axios'

const instance = axios.create({
  withCredentials: true
})

export default {
  namespaced: true,
  state: {
    authenticated: false,
    user: [],
    ifua_number: '',
    access_token: ''
  },

  getters: {
    check(state) {
      return state.authenticated
    },
    user(state) {
      return state.user
    },
    ifua_number: state => state.ifua_number,
    access_token: state => state.access_token
  },
  mutations: {
    SET_AUTHENTICATED(state, value) {
      state.authenticated = value
    },
    SET_USER(state, value) {
      state.user = value
    },
    SET_IFUA(state, value) {
      state.ifua_number = value
    },
    SET_ACCESS_TOKEN(state, value) {
      state.access_token = value
    },

  },
  actions: {
    async login({ commit, dispatch }, credentials) {

      await instance.get(`${process.env.VUE_APP_ROOT_API}/sanctum/csrf-cookie`, { withCredentials: true })
      const data_login = await instance.post(`${process.env.VUE_APP_ROOT_API}/api/2821`, credentials)

      commit('SET_ACCESS_TOKEN', data_login.data.data.access_token);
      dispatch('me')
    },

    async me({ commit }) {
      try {

        let { data } = await instance.get(`${process.env.VUE_APP_ROOT_API}/api/2321`)

        commit('SET_AUTHENTICATED', true)
        commit('SET_USER', data.data)
        commit('SET_IFUA', data.data)
      } catch (e) {
        commit('SET_AUTHENTICATED', false)
        commit('SET_USER', [])
        commit('SET_IFUA', [])
      }
    },



    async signout({ dispatch }) {

      await instance.post(`${process.env.VUE_APP_ROOT_API}/logout`);

      dispatch('me')
    },

  },
}